export const ExclamationCircle20Icon: React.FC<
  React.SVGProps<SVGSVGElement>
> = (props) => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="100%"
        viewBox="0 0 20 20"
        fill="none"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...props}
      >
        <g clipPath="url(#clip0_897_750)">
          <circle
            cx="10"
            cy="14.1667"
            r="0.833333"
            transform="rotate(-180 10 14.1667)"
            fill="currentColor"
          />
          <path
            d="M9.99999 11.6667L9.99999 5.83341M18.3333 10.0001C18.3333 14.6025 14.6024 18.3334 9.99999 18.3334C5.39762 18.3334 1.66666 14.6025 1.66666 10.0001C1.66666 5.39771 5.39762 1.66675 9.99999 1.66675C14.6024 1.66675 18.3333 5.39771 18.3333 10.0001Z"
            stroke="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_897_750">
            <rect width="20" height="20" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};
